@import '../../global/styles/anchors/anchor';
@import '../../global/variables/grid';

:host {
  height: var(--lgr-spacing-xs);
  box-sizing: border-box;
  border-bottom: var(--lgr-border-size-default) solid var(--lgr-color-neutral-low-light);
  flex: 1;
  font-size: var(--lgr-font-size-sm);

  @media (min-width: $lgr-grid-md-break-point) {
    font-size: var(--lgr-font-size-md);
  }

  li {
    all: unset;
    display: block;
    height: 100%;

    a {
      @include common-link-styles;
      display: block;
      height: 100%;
      box-sizing: border-box;
      margin: 0;
      padding-inline: var(--lgr-spacing-nano);
      padding-bottom: var(--lgr-spacing-nano);
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--lgr-color-neutral-low-dark);

      &.highlighted {
        padding-bottom: calc(var(--lgr-spacing-nano) - 1px);
        border-bottom: 2px solid var(--lgr-color-neutral-low-dark);
        outline: unset;
      }

      &:hover {
        color: var(--lgr-color-neutral-low-dark);
        border-color: var(--lgr-color-neutral-low-dark);
      }

      &:active {
        color: var(--lgr-color-neutral-low-dark);
        border-color: var(--lgr-color-neutral-low-dark);
      }

      &.disabled {
        border-color: var(--lgr-color-neutral-low-light);
      }

      &.inverse {
        border-color: var(--lgr-color-neutral-high-pure);

        &:hover,
        &.disabled {
          opacity: var(--lgr-alpha-intense);
        }

        &:active {
          opacity: 1;
        }
      }
    }
  }
}

:host(.inverse) {
  border-color: var(--lgr-color-neutral-high-pure);
}